import { AiTestNameTableDialog } from "@src/components/Dialogs/AiTestNameTableDialog";
import { OnsiteEditorDeprecationDialog } from "@src/components/Dialogs/OnsiteEditorDeprecationDialog";
import { ConnectToShopifyDialog } from "@src/components/Dialogs/ConnectToShopifyDialog";
import { ForceReloadDialog } from "@src/components/Dialogs/ForceReloadDialog";
import { OnboardingDialog } from "@src/components/MainApp/Onboarding/OnboardingDialog";
import { EarlyTestReportDialog } from "@src/features/experiments/components/earlyTestGuard/EarlyTestReportDialog";
import { RevertFeedbackDialog } from "@src/features/experienceBuilder/common/RevertFeedbackDialog";
import { FirstExperienceLaunchedDialog } from "@src/features/getStarted/components/FirstExperienceLaunchedDialog";
import { SchedulePersonalizationDialog } from "@src/features/scheduleExperience/SchedulePersonalizationDialog";
import { useDialogs } from "@src/hooks/dialog";

import { CmdKDialog } from "../components/Dialogs/CmdKDialog";
import { ConfirmExperienceResetDialog } from "../components/Dialogs/ConfirmExperienceResetDialog";
import { MissingShopifyScopeDialog } from "../components/Dialogs/MissingShopifyScopeDialog";
import { ScriptTagDialog } from "../components/Dialogs/ScriptTagDialog";
import { UpdateDetectedDialog } from "../components/Dialogs/UpdatedDetectedDialog";
import { ExperienceBuilderDialog } from "@src/features/experienceBuilder/ExperienceBuilderDialog";

export const DialogProvider = () => {
  const { getDialogProps, isDialogOpen } = useDialogs();
  const onsiteEditorDeprecationProps = getDialogProps(
    "onsiteEditorDeprecation"
  );
  return (
    <>
      <ForceReloadDialog />
      <FirstExperienceLaunchedDialog />
      <MissingShopifyScopeDialog />
      <UpdateDetectedDialog />
      {isDialogOpen("scriptTag") && <ScriptTagDialog />}
      <ConnectToShopifyDialog />
      {isDialogOpen("confirmReset") && <ConfirmExperienceResetDialog />}
      {isDialogOpen("schedulePersonalization") && (
        <SchedulePersonalizationDialog />
      )}
      <OnboardingDialog />
      <CmdKDialog />
      <RevertFeedbackDialog />
      {isDialogOpen("testNameReviewDialog") && <AiTestNameTableDialog />}
      {isDialogOpen("experienceBuilder") && <ExperienceBuilderDialog />}
      {onsiteEditorDeprecationProps && (
        <OnsiteEditorDeprecationDialog
          onAcknowledge={onsiteEditorDeprecationProps.onAcknowledge}
          onContactUs={onsiteEditorDeprecationProps.onContactUs}
        />
      )}
      {isDialogOpen("earlyTestReport") && <EarlyTestReportDialog />}
    </>
  );
};
